<template>
  <ul id="social-media" :class="[display, float]">
    <li v-for="network in networks" :key="networks.indexOf(network)" class="center-align">
      <a :href="network.link" target="_blank" class="network">
        <div :class="type">
          <font-awesome-icon
            :icon="[network.iconType, network.icon]"
            data-aos="zoom-in"
            data-aos-duration="500"
            :data-aos-delay="network.delay"
          ></font-awesome-icon>
        </div>
      </a>
    </li>
  </ul>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

export default {
  name: 'SocialMedia',
  components: {
    FontAwesomeIcon,
  },
  props: {
    display: String,
    float: String,
    type: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      networks: [
        {
          link:
            'mailto:/info@bgsestudiojuridico.com',
          icon: 'paper-plane',
          iconType: 'fas',
          delay: 300,
        },
        {
          link: 'https://www.linkedin.com/in/tomasrequena/',
          icon: 'linkedin-in',
          iconType: 'fab',
          delay: 600,
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
ul#social-media {
  list-style: none;
  padding: 10px 0;

  &.right {
    float: right;
  }

  &.left {
    float: left;
  }

  li {
    display: inline-flex;
    margin: 0 20px 0 0;

    a.network {
      width: 100%;
      text-decoration: none;

      div {
        width: 50px;
        padding: 10px 0;
        border-radius: 5px;
        -webkit-transition: background-color 0.3s, font-size 0.15s;
        transition: background-color 0.3s, font-size 0.15s;

        &.solid {
          background-color: #e3e3e3;
          color: #212121;
        }

        &.clear {
          background-color: transparent;
          color: #fff;
          // border: 1px solid #fff;
          border-radius: 5px;
        }

        svg {
          transition: font-size 2s;
          font-size: 24px;
        }
      }

      &:hover {
        div {
          &.solid {
            background-color: #f16334;
            color: white;
          }

          &.clear {
            background-color: #fff;
            color: #212121;

            svg {
              font-size: 28px;
            }
          }
        }
      }
    }
  }
}
</style>
